import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { FoldersGridViewComponent } from './folders-grid-view.component';
import { GoMaterialModule } from '@go-modules/go-material.module';
import { GridVirtualScrollViewportModule } from '@go-modules/components/grid-virtual-scroll-viewport/grid-virtual-scroll-viewport.module';
import { FolderCardModule } from '@dashboard/app/components/folders-view/folder-card/folder-card.module';

@NgModule({
	imports: [
		CommonModule,
		TranslateModule,
		GoMaterialModule,
		FolderCardModule,
		GridVirtualScrollViewportModule
	],
	declarations: [
		FoldersGridViewComponent
	],
	exports: [
		FoldersGridViewComponent
	]
})
export class FoldersGridViewModule {}
